<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年05月18日 15:29:19 +0800
 * @最后修改时间: 2022-04-13 12:44:50
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimRecord\ClaimRecord.vue
-->

<template>
  <ContentLayout
    pad="0"
    :title="$t('label_essweb_ClaimRecord_list_title')"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
    :exportBtn="hasBtn('export-admin-claim-record')"
    :importBtn="hasBtn('import-admin-claim-record')"
    :import-options="{
      api: '/claim-records/import/',
      templateUrl:
        'https://assets.essencehr.io/web/ess-business/assets/claim-transaction-record-import-template.xlsx',
      success: (result) => {
        getList(null, 1, $tableSetting.perPageSize, () => {
          $store.dispatch('resetTable', new Date().getTime());
        });
      },
    }"
    @export="onExport"
  >
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :showSelect="showSelect"
        :totalCount="totalCount"
        :filter-page-data="filterPageData"
        overLoading
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.applicant="{ item }">
          <div style="max-width: 300px">
            <v-list-item dense two-line class="pa-0" v-if="item.agent_staff">
              <v-list-item-avatar size="36" class="mr-1 my-0">
                <StaffAvatar
                  size="36"
                  :src="item.agent_staff.staff_avatar"
                  :staff_name="item.agent_staff.preferred_name"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="table-title text--primary">
                  {{ $getCommonLangValue(item.agent_staff.preferred_name) }}
                  <span class="text--secondary text-caption-xs">
                    {{ item.agent_staff.staff_code }}</span
                  >
                </v-list-item-title>
                <v-list-item-subtitle class="table-subtitle text--secondary">
                  {{ $getCommonLangValue(item.agent_staff.job_post_name) }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
        <template v-slot:item.swift_number="{ item }">
          {{ item.swift_number }}
        </template>
        <template v-slot:item.claim_form_name="{ item }">
          {{ $getCommonLangValue(item.claim_form_name) }}
        </template>
        <template v-slot:item.amount="{ item }"
          >{{ item.currency_code }}
          {{ $get_thousand_num(item.claim_total_amount) }}</template
        >
        <template v-slot:item.date="{ item }">
          {{ $getDateTime(item.submission_utc_datetime, "YYYY/MM/DD") }}
        </template>
        <template v-slot:item.pay_status="{ item }">
          <v-tooltip bottom v-if="Number(item.payment_status_uuid) === 1">
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs" style="width: 24px">
                <!-- <span
                  class="material-icons-round green--text"
                  v-if="Number(item.payment_status_uuid) === 1"
                >
                  check_circle
                </span> -->
                <svg-icon
                  size="24"
                  fill="transparent"
                  :iconClass="
                    Number(item.payment_status_uuid) === 1 ? 'Done' : ''
                  "
                />
                <!-- Alert -->
              </div>
            </template>
            {{ $t("label_essweb_ClaimRecord_form_paymentCompleteLabel") }}
          </v-tooltip>
          <!-- <span>
            {{ $getCommonLangValue(ClaimRecordData.payment_status_detail) }}
          </span> -->
        </template>
        <template v-slot:item.status="{ item }">
          <StatusChip
            :slideColor="item.approval_tint_color"
            :bgColor="item.approval_bg_color"
          >
            <template v-slot:status>
              {{ $getCommonLangValue(item.status_detail) }}
            </template>
          </StatusChip>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn
            icon
            @click="toView(item.uuid)"
            v-if="hasBtn('view-admin-claim-record')"
          >
            <svg-icon size="24" fill="currentColor" iconClass="viewDetail" />
          </v-btn>
        </template>
      </Tabler>
    </template>
    <!-- content -->
  </ContentLayout>
</template>
<script>
export default {
  name: "ClaimRecord",
  computed: {},
  data() {
    return {
      search: "",
      showSelect: false,
      totalCount: 0,
      filterPageData: null,
      headers: [
        {
          text: "label_essweb_ClaimRecord_form_swiftNumberLabel",
          value: "swift_number",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimRecord_list_applicantLabel",
          value: "applicant",
          align: "start",
          sortable: false,
        },

        {
          text: "label_essweb_ClaimRecord_list_claimFormNameLabel",
          value: "claim_form_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimRecord_list_amountLabel",
          // essweb_ClaimRecord_form_dialog_approvalAmountLabel buglist 1497 mel
          value: "amount",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimRecord_list_submitDateLabel",
          value: "date",
          align: "start",
          sortable: true,
          sort: (prop, desc, calback) => {
            return this.$sortList(
              this.desserts,
              "submission_utc_datetime",
              desc ? true : false,
              "datetime"
            ).then((res) => {
              calback(desc);
              this.desserts = res;
            });
          },
        },
        {
          text: "label_essweb_ClaimRecord_form_paymentStatusLabel",
          value: "pay_status",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimRecord_list_statusLabel",
          value: "status",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      page: 1,
      desserts: [],
      filterObjects: [
        // {
        //   type: "string",
        //   sequence: 0,
        //   position: "right",
        //   name: "claim_form_name",
        //   label: "label_essweb_ClaimRecord_list_claimFormNameLabel",
        //   value: "",
        //   data: undefined,
        // },
        {
          type: "string",
          sequence: 0,
          name: "swift_number",
          position: "right",
          label: "label_essweb_ClaimRecord_form_swiftNumberLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 1,
          showKey: "preferred_name",
          subKey: "job_post_name",
          position: "right",
          name: "applicant",
          multiple: true,
          avatar: true,
          twoLine: true,
          label: "label_essweb_ClaimRecord_list_applicantLabel",
          value: [],

          selected: [],
          data: {
            api: "/staff/get-staff-list/",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "daterange",
          sequence: 2,
          name: "date",
          position: "right",
          label: "label_essweb_ClaimRecord_list_submitDateLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "select",
          sequence: 3,
          position: "right",
          name: "pay_status",
          multiple: false,
          label: "label_essweb_ClaimRecord_form_paymentStatusLabel",
          value: "",

          selected: [],
          data: {
            api: "ess_payment_status_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 3,
          position: "right",
          name: "status",
          statusChip: "approval",
          multiple: true,
          label: "label_essweb_ClaimRecord_list_statusLabel",
          value: [],

          selected: [],
          data: {
            api: "ess_approval_status_detail_select",
            url_type: "prompt",
            args: null,
            table: "x",
            type: "",
            modelKey: "view_fields",
            valueKey: "value_field",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 4,
          position: "right",
          showKey: "dict_label",
          name: "staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
      ],
    };
  },
  watch: {},
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    onExport() {
      const that = this;
      let object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "applicant")
          data["staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "date") {
          data["start_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[0] : ""
          );
          data["end_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[1] : ""
          );
        }
        if (item["name"] == "swift_number") {
          data["swift_number"] = item.value;
        }
        if (item["name"] == "pay_status") {
          data["payment_status_uuid"] = item.value;
        }
        if (item["name"] == "status") {
          data["status_detail"] = item.value.join(",");
        }
        if (item["name"] == "staff_status")
          data["staff_status"] = item.value ? item.value.join(",") : "";
      });
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_form_records",
        url: "/claim-records/export/",
        data: data,
        type: "export",
        export_title: this.$t("label_essweb_ClaimRecord_list_title"),
      });
    },
    toFilter(callback) {
      const that = this;
      let object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "applicant")
          data["staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "date") {
          data["start_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[0] : ""
          );
          data["end_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[1] : ""
          );
        }
        if (item["name"] == "swift_number") {
          data["swift_number"] = item.value;
        }
        if (item["name"] == "pay_status") {
          data["payment_status_uuid"] = item.value;
        }
        if (item["name"] == "status") {
          data["status_detail"] = item.value.join(",");
        }
        if (item["name"] == "staff_status")
          data["staff_status"] = item.value ? item.value.join(",") : "";
      });
      this.getList(data, 1, this.$tableSetting.perPageSize, callback);
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_claim_form_records",
        url: "/claim-records/get-claim-records-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage, data) : null;
      });
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_claim_form_records",
        url: "/claim-records/delete-claim-records-table/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_ClaimRecord_list_deleteClaimRecordSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toView: function (uuid) {
      this.$toPage(
        "/admin/claim-record/detail/" +
          this.$aesEncrypt(
            JSON.stringify({
              id: uuid,
            })
          )
      );
    },
  },
};
</script>
